import {createSlice} from "@reduxjs/toolkit";

export interface ISettings {
    toggle: boolean,
}

const initialState: ISettings = {
    toggle: false,
};
export const SettingsSlice = createSlice({
    name: "step_slice",
    initialState,
    reducers: {
        toggleDropdown: (state) => {
            state.toggle = !state.toggle;
        },
        toggleState:(state) => {
            state.toggle = !state.toggle
        }
    },
});

export const {
    toggleDropdown,
    toggleState
} = SettingsSlice.actions;

export default SettingsSlice.reducer;